module.exports = __webpack_public_path__ + "img/宣传_116.a66ac1f2.jpg";